import {
  Stethoscope, Cog, Laptop, Brain, BarChart3, Pill, Dna,
  Briefcase, TrendingUp, GraduationCap, Building2,
} from 'lucide-react';
import { STUDY_PROGRAMS } from '@/data/content';
import { useCounsellingModal } from './CounsellingModal';

const ICON_MAP = {
  stethoscope: Stethoscope, cog: Cog, laptop: Laptop, brain: Brain,
  chart: BarChart3, pill: Pill, dna: Dna, briefcase: Briefcase,
  trending: TrendingUp, mind: Brain, building: Building2,
  graduation: GraduationCap, doctorate: GraduationCap,
};

const Programs = () => {
  const { open } = useCounsellingModal();

  return (
    <section className="programs-section" data-testid="programs-section">
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Study Programs</div>
          <h2 className="section-title">Choose Your <span className="gold-gradient">Path</span></h2>
          <p className="section-subtitle">
            From MBBS to PhD — explore Bachelor's, Master's and Doctorate programs across leading European universities.
          </p>
        </div>

        <div className="program-grid">
          {STUDY_PROGRAMS.map((p) => {
            const Icon = ICON_MAP[p.icon] || GraduationCap;
            return (
              <div
                key={p.id}
                className="program-card"
                data-testid={`program-${p.id}`}
                onClick={() => open({ source: 'program_card', course: p.name })}
              >
                <div className="program-icon">
                  <Icon size={22} />
                </div>
                <h4>{p.name}</h4>
                <p>{p.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Programs;
